export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;

export const defaultLocale = 'vn';
export const defaultListen = true;
export const localeOptions = [
  { id: 'en', name: 'English', direction: 'ltr' },
  { id: 'vn', name: 'Vietnamese', direction: 'ltr' },
];

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
